__turbopack_context__.v({
  "container": "ExpandableSidebar-module-scss-module__pWuK4q__container",
  "container-left": "ExpandableSidebar-module-scss-module__pWuK4q__container-left",
  "container-right": "ExpandableSidebar-module-scss-module__pWuK4q__container-right",
  "item": "ExpandableSidebar-module-scss-module__pWuK4q__item",
  "item-text": "ExpandableSidebar-module-scss-module__pWuK4q__item-text",
  "items-container": "ExpandableSidebar-module-scss-module__pWuK4q__items-container",
  "title": "ExpandableSidebar-module-scss-module__pWuK4q__title",
});
